<template>
	<div>
		<div class="header-container">
			<a-breadcrumb class="breadcrumb">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="handleAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="handleEdit" :disabled="!tableSelectedRow">编辑</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="handleDelete" :disabled="!tableSelectedRow">删除</a-button>
			</div>
		</div>
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="服务商查询">
				<div class="query-container">
					<div class="query-item">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="query-item query-item-end">
						<a-button type="primary" icon="search" @click="apiFormTemplateQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table 
				:row-selection="rowSelection" 
				:columns="tableColumns" 
				:data-source="formItems" 
				row-key="id" 
				:pagination="false" 
				:loading="tableLoading">
				<template slot="type" slot-scope="text">
					<span v-if="text === 'input'">输入框(input)</span>
					<span v-else-if="text === 'radio'">单选(radio)</span>
					<span v-else-if="text === 'checkbox'">多选(checkbox)</span>
					<span v-else-if="text === 'select'">下拉选择(select)</span>
					<span v-else-if="text === 'textarea'">文本域(textarea)</span>
					<span v-else-if="text === 'date'">日期选择(date)</span>
					<span v-else>{{text}}</span>
				</template>
				
				<template slot="dataSet" slot-scope="text, record">
					<span v-if="record.type === 'radio' || record.type === 'checkbox' || record.type === 'select'">
						<span v-if="record.dataSet && record.dataSet.length > 0">
							{{record.dataSet.map(item => `${item.label}=${item.value}`).join(',')}}
						</span>
						<span v-else class="empty-text">-</span>
					</span>
					<span v-else class="empty-text">-</span>
				</template>
			</a-table>
			
			<!-- <div v-if="formItems.length === 0" class="empty-tip">
			</div> -->
		</div>

		<!-- 编辑弹窗 -->
		<a-modal 
			class="qa-modal" 
			:title="editForm.id ? '编辑表单项' : '新增表单项'" 
			:visible="editVisible" 
			@cancel="editHandleCancel" 
			:maskClosable="false" 
			:keyboard="false">
			<div class="modal-content">
				<a-form-model 
					ref="editRuleForm" 
					:model="editForm" 
					:label-col="{span: 3}" 
					:wrapper-col="{span: 21}" 
					:rules="editRules"
					labelAlign="left"
					class="form-template-form">
					<a-form-model-item label="输入类型" has-feedback prop="type">
						<a-select v-model="editForm.type" @change="handleInputTypeChange" class="form-input-full">
							<a-select-option value="input">输入框(input)</a-select-option>
							<a-select-option value="radio">单选(radio)</a-select-option>
							<a-select-option value="checkbox">多选(checkbox)</a-select-option>
							<a-select-option value="select">下拉选择(select)</a-select-option>
							<a-select-option value="textarea">文本域(textarea)</a-select-option>
							<a-select-option value="date">日期选择(date)</a-select-option>
						</a-select>
					</a-form-model-item>
					
					<a-form-model-item label="显示内容" has-feedback prop="displayContent">
						<a-input v-model="editForm.displayContent" placeholder="请输入显示内容" class="form-input-full" />
					</a-form-model-item>
					
					<a-form-model-item label="字段名" has-feedback prop="fieldName">
						<a-input v-model="editForm.fieldName" placeholder="请输入字段名" class="form-input-full" />
					</a-form-model-item>

					<a-form-model-item label="是否必填" has-feedback prop="isRequired">
						<a-radio-group v-model="editForm.isRequired">
							<a-radio :value="1">是</a-radio>
							<a-radio :value="0">否</a-radio>
						</a-radio-group>
					</a-form-model-item>
					
					
					<a-form-model-item label="排序" has-feedback prop="sort">
						<a-input-number v-model="editForm.sort" :min="1" class="form-input-full" />
					</a-form-model-item>
					
					<a-form-model-item 
						label="数据集" 
						has-feedback 
						prop="dataSet"
						v-if="editForm.type === 'radio' || editForm.type === 'checkbox' || editForm.type === 'select'">
						<div class="dataset-container">
							<div 
								v-for="(item, index) in editForm.dataSet" 
								:key="index" 
								class="dataset-item">
								<a-input 
									v-model="item.label" 
									placeholder="显示文本" 
									class="dataset-input" />
								<span class="dataset-equals">=</span>
								<a-input 
									v-model="item.value" 
									placeholder="值" 
									class="dataset-input" />
								<a-button 
									type="link" 
									danger 
									icon="delete" 
									@click="removeDataSetItem(index)" 
									v-if="editForm.dataSet.length > 1"
									class="dataset-delete-btn">
									删除
								</a-button>
							</div>
							<a-button 
								type="dashed" 
								icon="plus" 
								@click="addDataSetItem" 
								class="dataset-add-btn">
								添加选项
							</a-button>
						</div>
					</a-form-model-item>
				</a-form-model>
			</div>
			<template slot="footer">
				<div class="modal-footer">
					<a-button @click="editHandleCancel">取消</a-button>
					<a-button type="primary" @click="handleSave" :loading="saveLoading">保存</a-button>
				</div>
			</template>
		</a-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					parentId: 0,
					facilitatorName: '',
					facilitatorCode: '',
					facilitatorId: ''
				},
				facilitatorList:[],
				facilitatorId: '',
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu') || '表单模板',
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu') || '自定义表单',
				saveLoading: false,
				tableLoading: false,
				formItems: [],
				itemIdCounter: 0,
				tableSelectedRow: null,
				editVisible: false,
				editForm: {
					id: null,
					facilitatorId:'',
					type: 'input',
					displayContent: '',
					fieldName: '',
					sort: 1,
					dataSet: []
				},
				editRules: {
					type: [{ required: true, message: '请选择输入类型', trigger: 'change' }],
					displayContent: [{ required: true, message: '请输入显示内容', trigger: 'blur' }],
					fieldName: [{ required: true, message: '请输入字段名', trigger: 'blur' }],
					isRequired: [{ required: true, message: '请选择是否必填', trigger: 'change' }],
					sort: [{ required: true, type: 'number', min: 1, message: '请输入排序', trigger: 'blur' }]
				},
				tableColumns: [
					{
						title: '排序',
						dataIndex: 'sort',
						key: 'sort',
						align: 'center',
						width: 100
					},
					{
						title: '输入类型',
						dataIndex: 'type',
						key: 'type',
						align: 'center',
						width: 180,
						scopedSlots: { customRender: 'type' }
					},
					{
						title: '显示内容',
						dataIndex: 'displayContent',
						key: 'displayContent',
						align: 'center'
					},
					{
						title: '字段名',
						dataIndex: 'fieldName',
						key: 'fieldName',
						align: 'center'
					},
					{
						title: '数据集',
						dataIndex: 'dataSet',
						key: 'dataSet',
						align: 'center',
						width: 350,
						scopedSlots: { customRender: 'dataSet' }
					}
				]
			};
		},
		methods: {
			// 新增
			handleAdd() {
				this.editForm = {
					id: null,
					type: 'input',
					displayContent: '',
					fieldName: '',
					sort: this.formItems.length + 1,
					dataSet: []
				};
				this.editVisible = true;
			},
			
			// 编辑
			handleEdit() {
				if (!this.tableSelectedRow) {
					this.$message.warning('请选择要编辑的数据');
					return;
				}
				// 深拷贝选中的数据
				this.editForm = JSON.parse(JSON.stringify(this.tableSelectedRow));
				// 确保dataSet是数组
				if (!this.editForm.dataSet) {
					this.editForm.dataSet = [];
				}
				// 如果是radio、checkbox或select类型且数据集为空，初始化一个空项
				if ((this.editForm.type === 'radio' || this.editForm.type === 'checkbox' || this.editForm.type === 'select') && this.editForm.dataSet.length === 0) {
					this.editForm.dataSet = [{ label: '', value: '' }];
				}
				this.editVisible = true;
			},
			
			// 删除
			handleDelete() {
				if (!this.tableSelectedRow) {
					this.$message.warning('请选择要删除的数据');
					return;
				}
				this.$confirm({
					title: '确定要删除这个表单项吗？',
					content: `显示内容：${this.tableSelectedRow.displayContent}`,
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk: () => {
						const index = this.formItems.findIndex(item => item.id === this.tableSelectedRow.id);
						if (index > -1) {
							this.formItems.splice(index, 1);
							this.tableSelectedRow = null;
							this.$message.success('删除成功');
						}
					}
				});
			},
			
			
			// 输入类型改变
			handleInputTypeChange() {
				// 如果是radio、checkbox或select类型，初始化数据集
				if (this.editForm.type === 'radio' || this.editForm.type === 'checkbox' || this.editForm.type === 'select') {
					if (!this.editForm.dataSet || this.editForm.dataSet.length === 0) {
						this.editForm.dataSet = [
							{ label: '', value: '' }
						];
					}
				} else {
					this.editForm.dataSet = [];
				}
			},
			
			// 添加数据集项
			addDataSetItem() {
				if (!this.editForm.dataSet) {
					this.editForm.dataSet = [];
				}
				this.editForm.dataSet.push({ label: '', value: '' });
			},
			
			// 删除数据集项
			removeDataSetItem(index) {
				this.editForm.dataSet.splice(index, 1);
			},
			
			// 编辑弹窗取消
			editHandleCancel() {
				this.editVisible = false;
				this.$refs.editRuleForm.resetFields();
				this.editForm = {
					id: null,
					type: 'input',
					displayContent: '',
					fieldName: '',
					sort: '',
					dataSet: []
				};
			},
			
			// 验证表单数据
			validateForm() {
				for (let i = 0; i < this.formItems.length; i++) {
					const item = this.formItems[i];
					if (!item.displayContent || item.displayContent.trim() === '') {
						this.$message.warning(`第${i + 1}项的显示内容不能为空`);
						return false;
					}
					if (!item.fieldName || item.fieldName.trim() === '') {
						this.$message.warning(`第${i + 1}项的字段名不能为空`);
						return false;
					}
					// 检查字段名是否重复
					for (let j = i + 1; j < this.formItems.length; j++) {
						if (item.fieldName === this.formItems[j].fieldName) {
							this.$message.warning(`字段名"${item.fieldName}"重复，请修改`);
							return false;
						}
					}
					// 如果是radio、checkbox或select类型，验证数据集
					if (item.type === 'radio' || item.type === 'checkbox' || item.type === 'select') {
						if (!item.dataSet || item.dataSet.length === 0) {
							this.$message.warning(`第${i + 1}项的数据集不能为空`);
							return false;
						}
						for (let k = 0; k < item.dataSet.length; k++) {
							const dataItem = item.dataSet[k];
							if (!dataItem.label || dataItem.label.trim() === '') {
								this.$message.warning(`第${i + 1}项的数据集第${k + 1}个选项的显示文本不能为空`);
								return false;
							}
							if (!dataItem.value || dataItem.value.toString().trim() === '') {
								this.$message.warning(`第${i + 1}项的数据集第${k + 1}个选项的值不能为空`);
								return false;
							}
						}
					}
				}
				return true;
			},
			
			// 构建提交数据
			buildTemplateItem(item) {
				if (item.type === 'radio' || item.type === 'checkbox' || item.type === 'select') {
					if (item.dataSet && item.dataSet.length > 0) {
						item.dataSet = item.dataSet.map(dataItem => `${dataItem.label}=${dataItem.value}`).join(',');
					}
				}
				console.log(item);
				return item;
			},
			
			// 保存模板（验证当前表单项并提交至服务端）
			handleSave() {
				this.$refs.editRuleForm.validate(async valid => {
					if (!valid) {
						return false;
					}

					const facilitatorId = this.query.facilitatorId || this.facilitatorId;
					if (!facilitatorId) {
						this.$message.warning('请选择所属服务商');
						return;
					}
					this.saveLoading = true;
					const templateItem = this.buildTemplateItem(this.editForm);
					templateItem.facilitatorId = facilitatorId;
					try {
						const { data: res } = await this.$http.post(this.editForm.templateId?this.navigation.apiFormTemplateEdit:this.navigation.apiFormTemplateAdd, templateItem);
						if (res.code === 200) {
							this.$message.success(res.msg || '保存成功');
							this.editVisible = false;
							this.resetForm();
						} else {
							this.$message.error(res.msg || '保存失败');
						}
					} catch (error) {
						console.error('保存失败:', error);
						this.$message.error('保存失败，请稍后重试');
					} finally {
						this.saveLoading = false;
					}
				});
			},

			resetForm() {
				this.tableSelectedRow = null;
				this.$refs.editRuleForm.resetFields();
				this.editForm = {
					id: null,
					type: 'input',
					displayContent: '',
					fieldName: '',
					sort: '',
					dataSet: []
				};
				this.apiFormTemplateQueryList();
			},
			
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data || [];
					if (!this.query.facilitatorId && this.facilitatorList.length) {
						this.query.facilitatorId = this.facilitatorList[0].facilitatorId;
					}
					this.apiFormTemplateQueryList();
				} else {
					this.$message.error(res.msg);
				}
			},
			async apiFormTemplateQueryList() {
				if (!this.query.facilitatorId) {
					this.formItems = [];
					return;
				}
				this.facilitatorId = this.query.facilitatorId;
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFormTemplateQueryList, this.query);
				if (res.code == 200) {
					const list = res.data.list || [];
					this.formItems = list.map((item, index) => {
						const newItem = Object.assign({
							id: item.id,
							type: 'input',
							displayContent: '',
							fieldName: '',
							sort: index + 1,
							dataSet: []
						}, item);
		
						if (typeof newItem.dataSet === 'string' && newItem.dataSet.length > 0) {
							newItem.dataSet = newItem.dataSet.split(',').filter(option => option).map(option => {
								const [label, value] = option.split('=');
								return {
									label: label || '',
									value: value || ''
								};
							});
						} else if (!Array.isArray(newItem.dataSet)) {
							newItem.dataSet = [];
						}
						return newItem;
					});
					if (this.formItems.length > 0) {
						const ids = this.formItems
							.map(item => item.id)
							.filter(id => typeof id === 'number' && !isNaN(id));
						this.itemIdCounter = ids.length ? Math.max(...ids) : this.formItems.length;
					}
				} else {
					this.$message.error(res.msg);
				}
			}
		},
		computed: {
			rowSelection() {
				let that = this;
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRow = selectedRows.length > 0 ? selectedRows[0] : null;
					}
				};
			}
		},
		created() {
			this.apiFacilitatorList();
			// 可以在这里加载已有的模板数据
		}
	};
</script>

<style scoped>
	/* 头部容器 */
	.header-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.breadcrumb {
		margin: 16px 0;
	}

	/* 查询区域 */
	.query-container {
		display: flex;
		justify-content: space-between;
	}

	.query-item {
		width: 30%;
		display: flex;
		align-items: center;
	}

	.query-item-end {
		justify-content: flex-end;
	}

	.query-label {
		width: 120px;
	}

	.query-input {
		width: 100%;
	}


	.qinang-button-margin {
		margin-left: 8px;
	}

	/* 空数据提示 */
	.empty-tip {
		text-align: center;
		padding: 40px;
		color: #999;
	}

	.empty-text {
		color: #999;
	}

	/* 弹窗样式 - 将滚动条设置在弹窗body层，宽度自适应 */
	.qa-modal ::v-deep .ant-modal {
		width: auto !important;
		max-width: 80vw;
	}

	.qa-modal ::v-deep .ant-modal-content {
		background-color: #fff;
		width: auto;
	}

	.qa-modal ::v-deep .ant-modal-body {
		max-height: calc(100vh - 110px);
		overflow-y: auto;
		padding: 24px;
		width: auto;
		position: relative;
	}

	/* 弹窗内容 */
	.modal-content {
		background-color: #fff;
		overflow: visible;
		min-width: 600px;
		max-width: 1000px;
		position: relative;
		height: calc(100vh - 160px);
	}

	/* 表单容器 - 移除内部滚动 */
	.form-template-form {
		width: 100%;
		overflow: visible;
		min-width: 600px;
	}

	/* 表单输入框 - 统一宽度，与数据集区域保持一致 */
	.form-input-full {
		width: 100%;
	}

	/* 数据集容器 - 设置固定宽度，确保所有输入框宽度一致 */
	.dataset-container {
		width: 100%;
	}

	/* 确保所有表单项的输入区域宽度一致 */
	.form-template-form ::v-deep .ant-form-item-control-wrapper {
		width: 100%;
		min-width: 500px;
	}

	.dataset-item {
		margin-bottom: 12px;
		display: flex;
		align-items: center;
		padding: 8px;
		background: #f5f5f5;
		border-radius: 4px;
	}

	.dataset-input {
		flex: 1;
		margin-right: 12px;
	}

	.dataset-equals {
		margin: 0 8px;
		color: #666;
		flex-shrink: 0;
	}

	.dataset-delete-btn {
		flex-shrink: 0;
	}

	.dataset-add-btn {
		width: 100%;
		margin-top: 8px;
	}

	/* 弹窗底部按钮 */
	.modal-footer {
		text-align: right;
	}

	.modal-footer .ant-btn {
		margin-left: 8px;
	}
</style>


